import script from "./leave-report.vue?vue&type=script&setup=true&lang=js"
export * from "./leave-report.vue?vue&type=script&setup=true&lang=js"

import "./leave-report.vue?vue&type=style&index=0&id=640a2298&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640a2298"]])

export default __exports__